export default "assets/images/logo_cordier_en-e4689fbf.png";